import type {
  DiversificationCategory,
  DiversificationScheme,
} from '@/store/diversificationsApi';

import { sortAndDeduplicateByName } from './diversificationOptions.utility';

export function categoryUsesTreeRelationships(args: {
  category: DiversificationScheme | null;
  options: DiversificationScheme[];
  categories: DiversificationCategory[];
}): boolean {
  const { category, options, categories } = args;

  if (!category) return false;

  const childOptions = sortAndDeduplicateByName(
    options.filter((option) => option.ParentId === category.DiversificationId),
  );

  if (childOptions.length === 0) return false;

  const knownCategoryIds = new Set(
    categories.map((item) => item.DiversificationCategoryId),
  );
  const apiGroupCount = categories.filter(
    (item) => item.ParentDiversificationId === category.DiversificationId,
  ).length;

  const hasUnknownChildCategoryReferences = childOptions.some(
    (option) =>
      option.DiversificationCategoryId != null &&
      !knownCategoryIds.has(option.DiversificationCategoryId),
  );
  const someChildHasChildren = childOptions.some((child) =>
    options.some((option) => option.ParentId === child.DiversificationId),
  );
  const someChildHasNoCategory = childOptions.some(
    (option) => option.DiversificationCategoryId == null,
  );
  const everyChildHasNoCategory = childOptions.every(
    (option) => option.DiversificationCategoryId == null,
  );

  return (
    hasUnknownChildCategoryReferences ||
    someChildHasChildren ||
    (someChildHasNoCategory && apiGroupCount <= 1) ||
    everyChildHasNoCategory
  );
}
